export default __webpack_public_path__ + "static/media/loginImg.715dee60.svg";